import PointMiniCard from './PointMiniCard';

export default PointMiniCard;
